export default __webpack_public_path__ + "img/3fb4ee0c845b7ceca85158b246f49f12.svg";